import classnames from 'classnames'

import PropTypes from 'prop-types'
import defaultAvatar from '../../assets/img/brand/img_avatar.png'

import { useHistory, useLocation } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { userLogout } from 'store/user/actions'

import { Link, useParams } from 'react-router-dom'
import { resetProxy } from 'store/Users/actions'
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Navbar,
  NavItem,
  Nav,
  ListGroup,
  ListGroupItem,
  Container,
  Row,
  Col,
  Spinner,
  Button,
  Dropdown,
  CardHeader,
} from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowLeft,
  faArrowUpRightFromSquare,
  faAward,
  faBars,
  faBell,
  faBook,
  faChartArea,
  faChartLine,
  faClipboardList,
  faCog,
  faComment,
  faGear,
  faGlobe,
  faGraduationCap,
  faLanguage,
  faLayerGroup,
  faMapMarkedAlt,
  faMessage,
  faPalette,
  faPlus,
  faQuestionCircle,
  faRightFromBracket,
  faTasks,
  faUserCog,
  faUsers,
  faUserTie,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import EditDashboard from './EditDashboard'
import kiwiLogo from '../../assets/img/brand/kiwi-logo.png'
import NavbarLink from './NavbarLink'

// Admin Navbar css
import './AdminNavbar.css'

// Global Css Leon
import '../../assets/css/Global/style.css'
import { useEffect, useRef, useState } from 'react'
import { setNavbarConversations } from 'store/Chats/actions'
import { setNavbarNotifications } from 'store/Notifications/actions'
import NavbarNotification from './NavbarNotification'
import ViewSubmissionModal from 'views/pages/MaintenanceLog/ViewSubmissionModal'
import TakeFormModal from 'views/pages/MaintenanceLog/TakeFormModal'
import { setSubmissionModalData } from 'store/Forms/actions'
import { setFillFormModalData } from 'store/Forms/actions'

import CardsHeader from 'components/Headers/CardsHeader'
import userReducer from 'store/user/reducer'
import { removeCourseFromNavbarNotifications } from 'store/Notifications/actions'
import { faSlack } from '@fortawesome/free-brands-svg-icons'

// const titleMappings = [
//   { path: '/learning-plan', title: 'LEARNING PLAN' },
//   { path: '/library', title: 'LIBRARY' },
//   { path: '/manager-report', title: 'MANAGER REPORT' },
//   { path: '/course/new', title: 'NEW COURSE' },
//   { path: '/report', title: 'MY REPORT' },
//   { path: '/all-courses', title: 'COURSE CATALOG' },
//   { path: '/compliance', title: 'COMPLIANCE' },
//   { path: '/config/general', title: 'GENERAL' },
//   { path: '/config/course', title: 'COURSE SETTINGS' },
//   { path: '/config/theme', title: 'THEME' },
//   { path: '/config/language', title: 'LANGUAGE' },
//   { path: '/settings/groups', title: 'COURSE GROUPS' },
//   { path: '/settings/users', title: 'USER MANAGEMENT' },
//   { path: '/settings/roles', title: 'USER ROLES' },
//   { path: '/role-groups', title: 'ROLE GROUPS' },
//   { path: '/settings/org-groups', title: 'LOCATION CATEGORIES' },
//   { path: '/settings/location-groups', title: 'LOCATION GROUPS' },
//   { path: '/settings/locations', title: 'LOCATIONS' },
//   { path: '/settings/rewards', title: 'REWARDS MANAGEMENT' },
//   { path: '/settings/question-bank', title: 'ADD QUESTIONS' },
//   { path: '/settings/external-reports', title: 'EXTERNAL REPORTS' },
//   { path: '/settings/help', title: 'CONTACT US' },
// ]

function AdminNavbar({
  theme = 'dark',
  sidenavOpen = false,
  toggleSidenav = () => {},
  title,
  courseName,
}) {
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const { enableExternalReports, enableRoleGroups } = useSelector(
    (state) => state.courseConfig,
  )
  const scaledDashboard = useSelector((state) => state.auth.scaledDashboard)
  const { submissionModalData, fillFormModalData } = useSelector(
    (store) => store.form,
  )
  const [activeTab, setActiveTab] = useState(0)
  const [previewNavbarColor, setPreviewNavbarColor] = useState(null)

  const { lastPathname } = useSelector((state) => state.courses)
  const user = useSelector((state) => state.auth.user)

  const languageData = languageRedux || {}
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const locationn = useLocation()

  const [notificationsDropdownOpen, setNotificationsDropdownOpen] =
    useState(false)

  const toggleNotificationsDropdown = () => {
    setNotificationsDropdownOpen(!notificationsDropdownOpen)
  }

  const { navbarConversations } = useSelector((store) => store.chat)
  const navbarNotifications = useSelector(
    (store) => store.notification.navbarNotifications,
  )

  const settingsDropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        settingsDropdownRef.current &&
        !settingsDropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false)
      }
    }

    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownOpen])

  const navbarStyle = !scaledDashboard
    ? {
        maxHeight: '10vh',
        minHeight: '10vh',
        height: '10vh',
      }
    : {
        maxHeight: '16.5vh',
        minHeight: '16.5vh',
        height: '16.5vh',
      }

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  useEffect(() => {
    setDropdownOpen(false)
  }, [locationn.pathname])

  useEffect(() => {
    if (dropdownOpen && window.innerWidth <= 768) {
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [dropdownOpen])

  const titleMappings = [
    {
      path: '/dashboard',
      title: `${user?.access !== 1 ? 'DASHBOARD' : ''}`,
    },
    {
      path: '/learning-plan',
      title: `${
        languageData.general ? languageData.general.learning_plan : ''
      }`.toUpperCase(),
    },
    {
      path: '/library',
      title: `${
        languageData.my_library ? languageData.my_library.back_to_library : ''
      }`.toUpperCase(),
    },
    {
      path: '/manager-report',
      title: `${
        languageData.general ? languageData.general.manager_report : ''
      }`.toUpperCase(),
    },
    {
      path: '/course/new',
      title: `${
        languageData.learning_plan ? languageData.learning_plan.new_course : ''
      }`.toUpperCase(),
    },
    {
      path: '/report',
      title: `${
        languageData.general ? languageData.general.my_report : ''
      }`.toUpperCase(),
    },
    {
      path: '/all-courses',
      title: `${
        languageData.general ? languageData.general.all_courses : ''
      }`.toUpperCase(),
    },
    {
      path: '/compliance',
      title: `${
        languageData.general ? languageData.general.compliance : ''
      }`.toUpperCase(),
    },
    { path: '/config/general', title: 'GENERAL' },
    {
      path: '/config/course',
      title: `${
        languageData.settings ? languageData.settings.course_settings : ''
      }`.toUpperCase(),
    },
    { path: '/config/theme', title: 'THEME' },
    {
      path: '/config/language',
      title: `${
        languageData.settings ? languageData.settings.language : ''
      }`.toUpperCase(),
    },
    {
      path: '/settings/groups',
      title: `${
        languageData.settings ? languageData.settings.group_management : ''
      }`.toUpperCase(),
    },
    {
      path: '/settings/users',
      title: `${
        languageData.settings ? languageData.settings.user_management : ''
      }`.toUpperCase(),
    },
    {
      path: '/public-catalog',
      title: 'PUBLIC CATALOG',
    },
    { path: '/settings/roles', title: 'USER ROLES' },
    {
      path: '/role-groups',
      title: `${
        languageData.groups ? languageData.groups.role_groups : ''
      }`.toUpperCase(),
    },
    {
      path: '/settings/org-groups',
      title: `${
        languageData.general ? languageData.general.location_categories : ''
      }`.toUpperCase(),
    },
    { path: '/settings/location-groups', title: 'LOCATION GROUPS' },
    {
      path: '/settings/locations',
      title: `${
        languageData.settings ? languageData.settings.locations : ''
      }`.toUpperCase(),
    },
    { path: '/settings/rewards', title: 'REWARDS MANAGEMENT' },
    { path: '/settings/question-bank', title: 'ADD QUESTIONS' },
    { path: '/settings/external-reports', title: 'EXTERNAL REPORTS' },
    {
      path: '/my-orders',
      title: `MY ORDERS`,
    },
    {
      path: '/job/create',
      title: `CREATE JOB`,
    },
    {
      path: '/job/edit',
      title: `EDIT JOB`,
    },
    {
      path: '/job-application',
      title: `JOB APPLICATION`,
    },
    {
      path: '/job/career',
      title: `CAREER`,
    },
    {
      path: '/forms',
      title: 'FORMS',
    },
    {
      path: '/messages',
      title: 'MESSAGES',
    },
    {
      path: '/job/details',
      title: `JOB DETAILS`,
    },
    {
      path: '/development',
      title: 'DEVELOPMENT',
    },
    {
      path: '/profile',
      title: 'PROFILE',
    },
    { path: '/notifications', title: 'NOTIFICATIONS' },
    {
      path: '/discussions',
      title: 'DISCUSSIONS',
    },
    {
      path: '/job-archived',
      title: `ARCHIVED JOBS`,
    },
    {
      path: '/job-candidates',
      title: 'JOB CANDIDATES',
    },
    { path: '/job-onboard', title: 'JOB ON-BOARDING' },
    { path: '/job-screening', title: 'JOB SCREENING' },
    { path: '/job/interview-schedule', title: 'INTERVIEW SCHEDULES' },
    { path: '/job/system-setup', title: 'SYSTEM SETUP' },
    {
      path: '/jobs',
      title: `MANAGE JOBS`,
    },

    {
      path: '/orders',
      title: `ORDERS`,
    },
    { path: '/slack-channels', title: 'SLACK CHANNELS' },
    {
      path: '/settings/help',
      title: `${
        languageData.settings ? languageData.settings.contact_us : ''
      }`.toUpperCase(),
    },
  ]

  const language = useSelector((state) => state.language.language?.data.general)
  const inViewCourse = useSelector((state) => state.courses.inViewCourse)
  const courses = useSelector((state) => state.courses)
  const general = useSelector((state) => state.generalConfig)
  const themeConfig = useSelector((state) => state.themeConfig)
  const themeLogo = themeConfig?.theme?.logo
  const history = useHistory()
  const location = useLocation()
  const params = useParams()

  const currentUrl = window.location.href

  const dispatch = useDispatch()

  const inEditCourse =
    location.pathname.includes('course') && location.pathname.includes('edit')
  const isNewCoursePage = location.pathname.includes('course/new')
  const isNewGroupPage = location.pathname.includes('group/new')
  const isUserTranscriptPage = location.pathname.includes(
    'manager-reports/employee/',
  )
  const inEditCourseGroup =
    location.pathname.includes('group') && location.pathname.includes('edit')

  const showGoback =
    inViewCourse ||
    inEditCourse ||
    isNewCoursePage ||
    isUserTranscriptPage ||
    inEditCourseGroup ||
    isNewGroupPage

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')

    // history.push('/auth/login')

    dispatch(userLogout())
  }

  const unReadConversations = navbarConversations?.filter(
    (conversation) =>
      !conversation?.last_message_read &&
      conversation?.last_message_sender !== user?.id,
  )

  const unReadNotifications = navbarNotifications?.filter(
    (notification) => !notification.read,
  )?.length

  const getTitle = () => {
    for (const { path, title } of titleMappings) {
      if (location.pathname.includes(path)) {
        return title
      }
    }
    return ''
  }

  const pageName = getTitle()

  const handleClickBackButton = (e) => {
    e.preventDefault()
    history.push(lastPathname)
    // const isCoursePathName =
    //   location.pathname.includes('course') && location.pathname.includes('edit')

    // if (isCoursePathName) {
    //   history.push('/learning-plan')
    // } else {
    //   window.history.back()
    // }
  }

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     dispatch(setNavbarConversations())
  //   }, 3000)

  //   return () => clearInterval(intervalId)
  // }, [dispatch])

  useEffect(() => {
    dispatch(setNavbarNotifications())
    dispatch(setNavbarConversations())
  }, [location.pathname, dispatch])

  // Listen for preview messages from admin iframe
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== 'http://localhost:5173') return

      if (event.data?.type === 'UPDATE_LEARNING_PREVIEW') {
        const { navbarColor } = event.data
        setPreviewNavbarColor(navbarColor || null)
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])

  return (
    <div
      className={`${
        themeConfig.theme.color && themeConfig.theme.color !== ''
          ? ''
          : 'bg-gradient-custom'
      }`}
      style={{
        backgroundColor:
          previewNavbarColor ||
          (themeConfig.theme.color && themeConfig.theme.color !== ''
            ? themeConfig.theme.color
            : undefined),
      }}
    >
      <Navbar
        className={classnames(
          'navbar-top navbar-expand',
          { 'navbar-dark': theme === 'dark' },
          { 'navbar-light bg-secondary': theme === 'light' },
        )}
        style={navbarStyle}
      >
        <Container fluid>
          <Collapse
            navbar
            // className='main-header-wrapper justifyBetween itemsCenter'
            className={`${
              inViewCourse && 'view-course-header-wrapper'
            } main-header-wrapper justifyBetween itemsCenter`}
            // style={{ paddingTop: courseName.length >= 35 && '100px' }}
            isOpen={true}
          >
            {inViewCourse ? (
              // <div className="d-none d-md-flex itemsCenter ">
              <div className='d-flex itemsCenter '>
                <Link to='/learning-plan'>
                  <div
                  // style={{
                  //   width: '140px',
                  //   cursor: 'pointer',
                  // }}
                  >
                    <img
                      alt='Logo'
                      style={{
                        maxWidth: '100%',
                        minWidth: '100%',
                        height: '50px',
                        objectFit: 'scale-down',
                      }}
                      className='navbar-brand-img mr10 '
                      src={themeLogo?.url ? themeLogo.url : kiwiLogo}
                    />
                  </div>
                </Link>
              </div>
            ) : null}
            {inViewCourse && (
              <div className='p-2 rounded nav_course-name_container'>
                {courseName ? (
                  <h3 className='text-white mb-0 nav_course-name'>
                    {courseName}
                  </h3>
                ) : (
                  <Spinner
                    className='text-white font-weight-lighter'
                    style={{ height: '20px', width: '20px' }}
                  />
                )}
              </div>
            )}
            <EditDashboard />
            {pageName ? (
              <div className='align-self-center'>
                <h3 className='text-white mb-0 pb-0'>{pageName}</h3>
              </div>
            ) : (
              // I added the empty div bc the navbar id don't have pageName to have same design with space between;
              <div></div>
            )}
            {/*<div className="d-flex itemsCenter ml-auto">*/}
            <div
              className={`d-flex align-items-center ${
                scaledDashboard && 'align-self-baseline'
              } `}
              style={{ gap: 'rem' }}
            >
              {' '}
              <Nav className='bg-transparent' navbar>
                <div
                  className='d-flex justify-content-between align-items-center'
                  style={{ gap: '15px' }}
                >
                  {showGoback && (
                    <a
                      className='align-self-center text-nowrap'
                      style={{ marginBottom: '2px' }}
                      href='/'
                      onClick={handleClickBackButton}
                    >
                      <span className='icon cursorPointer '>
                        {language ? (
                          <>
                            <FontAwesomeIcon
                              icon={faXmark}
                              style={{ fontSize: 'large' }}
                              size={'lg'}
                            />{' '}
                            <span className='back-text'>{language.back}</span>
                          </>
                        ) : (
                          <>
                            <FontAwesomeIcon
                              icon={faXmark}
                              style={{ fontSize: 'large' }}
                              size={'lg'}
                            />{' '}
                            <span className='back-text'>Exit</span>
                          </>
                        )}
                      </span>
                    </a>
                  )}
                  {location.pathname.includes('/course') ? null : (
                    <NavItem
                      className='d-xl-none align-self-center'
                      style={{ marginBottom: '2px' }}
                    >
                      <div
                        className={classnames(
                          'sidenav-toggler',
                          { active: sidenavOpen },
                          { 'sidenav-toggler-dark': theme === 'dark ' },
                        )}
                        onClick={toggleSidenav}
                      >
                        <div
                          className='sidenav-toggler-inner'
                          style={{ width: 'auto' }}
                        >
                          {/* <i
                          className='sidenav-toggler-line'
                          style={{
                            background: themeConfig.theme.sidebarTextColor,
                          }}
                        />
                        <i
                          className='sidenav-toggler-line'
                          style={{
                            background: themeConfig.theme.sidebarTextColor,
                          }}
                        />
                        <i
                          className='sidenav-toggler-line'
                          style={{
                            background: themeConfig.theme.sidebarTextColor,
                          }}
                        /> */}
                          {sidenavOpen ? (
                            <FontAwesomeIcon
                              icon={faXmark}
                              className='icon sidenav-toggler-line'
                              tabIndex='0'
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faBars}
                              className='icon sidenav-toggler-line'
                              tabIndex='0'
                            />
                          )}
                        </div>
                        {/* <FontAwesomeIcon icon={faGear}  /> */}
                      </div>
                    </NavItem>
                  )}
                  <UncontrolledDropdown
                    nav
                    class
                    // style={{ marginRight: '-15px' }}
                  >
                    <DropdownToggle
                      className='nav-link notifications px-0'
                      color=''
                      tag='a'
                    >
                      <FontAwesomeIcon
                        icon={faComment}
                        size='lg'
                        className=' icon'
                      />
                      {unReadConversations?.length ? (
                        <span
                          className='badge badge-danger notificationNumber'
                          style={{ right: '-5px' }}
                        >
                          {unReadConversations?.length === 6
                            ? '5+'
                            : unReadConversations?.length}
                        </span>
                      ) : null}
                    </DropdownToggle>
                    <DropdownMenu
                      className='notifications-dropdown dropdown-menu-xl py-0 overflow-hidden'
                      right
                    >
                      <div className='px-3 py-3'>
                        {navbarConversations?.length ? (
                          <h6 className='text-sm text-muted m-0'>
                            You have{' '}
                            <strong className='text-info'>
                              {unReadConversations?.length === 6
                                ? '5+'
                                : unReadConversations?.length}
                            </strong>{' '}
                            unread{' '}
                            {unReadConversations?.length == 1
                              ? 'message'
                              : 'messages'}
                            .
                          </h6>
                        ) : null}
                      </div>
                      <ListGroup flush>
                        {navbarConversations
                          ?.slice(0, 5)
                          ?.map((conversation) => (
                            <Link
                              key={conversation.id}
                              to={`/messages/${conversation?.id}`}
                            >
                              <DropdownItem className='list-group-item-action border'>
                                <Row className='align-items-center'>
                                  <Col className='col-auto'>
                                    {!conversation?.is_group ? (
                                      <img
                                        alt='...'
                                        className='avatar rounded-circle'
                                        src={
                                          JSON.parse(conversation?.message_user)
                                            ?.avatar
                                            ? JSON.parse(
                                                conversation?.message_user,
                                              )?.avatar?.url
                                            : defaultAvatar
                                        }
                                      />
                                    ) : (
                                      <>
                                        {conversation?.group_image ? (
                                          <img
                                            alt=''
                                            src={conversation?.group_image}
                                            className='avatar rounded-circle'
                                          />
                                        ) : (
                                          <FontAwesomeIcon
                                            icon={faUsers}
                                            size='lg'
                                            className='mr-3'
                                          />
                                        )}
                                      </>
                                    )}
                                  </Col>
                                  <div className='col ml--2'>
                                    <div className='d-flex justify-content-between align-items-center'>
                                      <div>
                                        <h4 className='mb-0 text-sm'>
                                          {!conversation?.is_group ? (
                                            <>
                                              {
                                                JSON.parse(
                                                  conversation?.message_user,
                                                )?.first_name
                                              }{' '}
                                              {
                                                JSON.parse(
                                                  conversation?.message_user,
                                                )?.last_name
                                              }
                                            </>
                                          ) : (
                                            conversation?.group_name
                                          )}
                                        </h4>
                                      </div>
                                      {conversation?.last_message_read == 0 &&
                                      user?.id !==
                                        conversation?.last_message_sender ? (
                                        <span
                                          className='dot top-0 start-100 translate-middle'
                                          style={{
                                            width: '10px',
                                            height: '10px',
                                            borderRadius: '50%',
                                            backgroundColor: '#00d4ff',
                                            border: '2px solid white',
                                          }}
                                        ></span>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                    <p className='text-sm mb-0'>
                                      {conversation?.is_group &&
                                      conversation?.last_message_text
                                        ? JSON.parse(conversation?.message_user)
                                            ?.user_id !== user?.id
                                          ? `${
                                              JSON.parse(
                                                conversation?.message_user,
                                              )?.first_name
                                            }: `
                                          : 'You: '
                                        : ''}
                                      {conversation?.last_message_text?.length >
                                      35
                                        ? `${conversation?.last_message_text?.slice(
                                            0,
                                            35,
                                          )}...`
                                        : conversation?.last_message_text}
                                    </p>
                                  </div>
                                </Row>
                              </DropdownItem>
                            </Link>
                          ))}
                      </ListGroup>

                      {/* <Link to='/messages'> */}
                      <Link to={`/messages/${navbarConversations[0]?.id}`}>
                        {navbarConversations?.length ? (
                          <DropdownItem className='text-center text-info font-weight-bold py-3'>
                            View All
                          </DropdownItem>
                        ) : (
                          <DropdownItem
                            className='text-center text-info font-weight-bold'
                            style={{ marginTop: '-30px' }}
                          >
                            Go to messages
                          </DropdownItem>
                        )}
                      </Link>
                    </DropdownMenu>
                  </UncontrolledDropdown>

                  {/* NOTIFICATION DROPDOWN */}

                  {submissionModalData.show && (
                    <ViewSubmissionModal
                      submissionId={submissionModalData.submission_id}
                      showViewSubmissionModal={submissionModalData.show}
                      closeModalFn={() =>
                        dispatch(setSubmissionModalData({ show: false }))
                      }
                      userId={submissionModalData.user_id}
                      setActiveTab={setActiveTab}
                      activeTab={activeTab}
                    >
                      {/* <DropdownStatus
                  changeStatus={handleStatusChange}
                  submissionStatus={submissionStatus}
                  dropdownRef={dropdownRef}
                /> */}
                    </ViewSubmissionModal>
                  )}
                  {fillFormModalData.show && (
                    <TakeFormModal
                      formId={fillFormModalData.formId}
                      showTakeFormModal={fillFormModalData.show}
                      setShowTakeFormModal={(show) =>
                        dispatch(
                          setFillFormModalData({
                            show,
                            formId: fillFormModalData.formId,
                          }),
                        )
                      }
                      setHasSubmissions={() => {}}
                    />
                  )}
                  <Dropdown
                    nav
                    class
                    className='nav'
                    isOpen={notificationsDropdownOpen}
                    toggle={toggleNotificationsDropdown}
                  >
                    <DropdownToggle
                      className='nav-link notifications px-0'
                      color=''
                      tag='a'
                    >
                      <FontAwesomeIcon
                        icon={faBell}
                        size='lg'
                        className=' icon'
                      />
                      {unReadNotifications ? (
                        <span
                          className='badge badge-danger notificationNumber'
                          style={{ right: '-5px' }}
                        >
                          {unReadNotifications !== 6
                            ? unReadNotifications
                            : '5+'}
                        </span>
                      ) : null}
                    </DropdownToggle>
                    <DropdownMenu
                      className='notifications-dropdown dropdown-menu-xl py-0 overflow-hidden'
                      style={{ zIndex: '100' }}
                      right
                    >
                      <div className='px-3 py-3'>
                        {navbarNotifications?.length ? (
                          <h6 className='text-sm text-muted m-0'>
                            You have{' '}
                            <strong className='text-info'>
                              {unReadNotifications === 6
                                ? '5+'
                                : unReadNotifications}
                            </strong>{' '}
                            unread{' '}
                            {unReadNotifications == 1
                              ? 'notification'
                              : 'notifications'}
                            .
                          </h6>
                        ) : null}
                      </div>

                      <ListGroup flush>
                        {navbarNotifications
                          ?.slice(0, 5)
                          ?.map((notification) => (
                            <NavbarNotification
                              navbar={true}
                              key={notification.id}
                              notification={notification}
                              closeDropdown={() =>
                                setNotificationsDropdownOpen(false)
                              }
                            />
                          ))}
                      </ListGroup>

                      <Link to='/notifications'>
                        {navbarNotifications?.length ? (
                          <DropdownItem className='text-center text-info font-weight-bold border py-3'>
                            View All
                          </DropdownItem>
                        ) : (
                          <DropdownItem
                            className='text-center text-info font-weight-bold'
                            style={{ marginTop: '-30px' }}
                          >
                            Go to notifications
                          </DropdownItem>
                        )}
                      </Link>
                    </DropdownMenu>
                  </Dropdown>
                  {/* <span className='text-white pr-2'>{title}</span> */}
                  <div
                    ref={settingsDropdownRef}
                    className='settings-dropdown-button '
                  >
                    <Button
                      color='transparent'
                      className='btn-icon-only btn-sm shadow-none'
                      onClick={() => {
                        toggleDropdown()
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faGear}
                        size='lg'
                        className=' icon'
                      />
                    </Button>

                    {dropdownOpen && (
                      <div className='bg-white dropdownMenuCard'>
                        <Button
                          color='transparent'
                          className='btn-icon-only btn-sm shadow-none x-closer'
                          onClick={() => {
                            toggleDropdown()
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faXmark}
                            size='lg'
                            className=' icon'
                          />
                        </Button>
                        <Row
                          style={{
                            margin: '0',
                          }}
                          className='p1 first-row-margin'
                          xs={1}
                          sm={1}
                          md={2}
                        >
                          {/* {window.innerWidth > 768 && ( */}
                          {/* <> */}
                          {[1, 2, 4, 5].includes(user?.access) && (
                            <>
                              <Col
                                className='dFlex flexCol itemCenter gap06 py06'
                                onClick={(e) => e.preventDefault()}
                              >
                                <small className='NavbarTitleText'>
                                  {languageData.settings
                                    ? languageData.settings.courses
                                    : 'Courses'}
                                </small>
                                <NavbarLink
                                  text={
                                    languageData.general
                                      ? languageData.general.learning_plan
                                      : 'Learning Plan'
                                  }
                                  link={'/learning-plan'}
                                >
                                  <FontAwesomeIcon
                                    size='lg'
                                    icon={faGraduationCap}
                                  />
                                </NavbarLink>
                                <NavbarLink
                                  text={
                                    languageData.settings
                                      ? languageData.settings.group_management
                                      : 'Course Groups'
                                  }
                                  link={'/settings/groups'}
                                >
                                  <FontAwesomeIcon
                                    size='lg'
                                    icon={faLayerGroup}
                                  />
                                </NavbarLink>
                              </Col>
                              <Col
                                className='dFlex flexCol itemCenter gap06 py06'
                                onClick={(e) => e.preventDefault()}
                              >
                                <small className='NavbarTitleText'>
                                  {languageData.general
                                    ? languageData.general.users
                                    : 'Users'}
                                </small>
                                <NavbarLink
                                  text={
                                    languageData.settings
                                      ? languageData.settings.user_management
                                      : 'User Management'
                                  }
                                  link={'/settings/users'}
                                >
                                  <FontAwesomeIcon size='lg' icon={faUserCog} />
                                </NavbarLink>
                                <NavbarLink
                                  text='User roles'
                                  link={'/settings/roles'}
                                >
                                  <FontAwesomeIcon size='lg' icon={faUserTie} />
                                </NavbarLink>

                                {enableRoleGroups === 1 ? (
                                  <NavbarLink
                                    text={
                                      languageData.groups?.role_groups
                                        ? languageData.groups.role_groups
                                        : 'Role Groups'
                                    }
                                    // text='Role Groups'
                                    link={'/settings/role-groups'}
                                  >
                                    <FontAwesomeIcon size='lg' icon={faUsers} />
                                  </NavbarLink>
                                ) : null}
                              </Col>
                            </>
                          )}
                          {user?.access === 1 && (
                            <>
                              <Col
                                className='dFlex flexCol itemCenter gap06 py06'
                                onClick={(e) => e.preventDefault()}
                              >
                                <small className='NavbarTitleText'>
                                  {languageData.general
                                    ? languageData.general.settings
                                    : 'Settings'}
                                </small>
                                <NavbarLink
                                  text='General'
                                  link={'/config/general'}
                                >
                                  <FontAwesomeIcon size='lg' icon={faCog} />
                                </NavbarLink>
                                <NavbarLink
                                  text={
                                    languageData.settings
                                      ? languageData.settings.course_settings
                                      : 'Course settings'
                                  }
                                  link={'/config/course'}
                                >
                                  <FontAwesomeIcon size='lg' icon={faTasks} />
                                </NavbarLink>
                                <NavbarLink
                                  text='Themes'
                                  link={'/config/theme'}
                                >
                                  <FontAwesomeIcon size='lg' icon={faPalette} />
                                </NavbarLink>
                                <NavbarLink
                                  text={
                                    languageData.settings
                                      ? languageData.settings.language
                                      : 'Language'
                                  }
                                  link={'/config/language'}
                                >
                                  <FontAwesomeIcon
                                    size='lg'
                                    icon={faLanguage}
                                  />
                                </NavbarLink>
                              </Col>
                              <Col
                                className='dFlex flexCol itemCenter gap06 py06'
                                onClick={(e) => e.preventDefault()}
                              >
                                <small className='NavbarTitleText'>
                                  {languageData.settings
                                    ? languageData.settings.locations
                                    : 'Location'}
                                </small>
                                <NavbarLink
                                  text={
                                    languageData.general
                                      ? languageData.general
                                          .certification_failed
                                      : 'Verification Failed'
                                  }
                                  link={'/settings/org-groups'}
                                >
                                  <FontAwesomeIcon size='lg' icon={faGlobe} />
                                </NavbarLink>
                                <NavbarLink
                                  text='Location groups'
                                  link={'/settings/location-groups'}
                                >
                                  <FontAwesomeIcon
                                    size='lg'
                                    icon={faMapMarkedAlt}
                                  />
                                </NavbarLink>
                                <NavbarLink
                                  text={
                                    languageData.settings
                                      ? languageData.settings.locations
                                      : 'Locations'
                                  }
                                  link={'/settings/locations'}
                                >
                                  <FontAwesomeIcon
                                    size='lg'
                                    icon={faMapMarkedAlt}
                                  />
                                </NavbarLink>
                              </Col>
                            </>
                          )}
                          {[1, 2, 4, 5].includes(user?.access) && (
                            <Col
                              className='dFlex flexCol itemCenter gap06 py06'
                              onClick={(e) => e.preventDefault()}
                            >
                              <small className='NavbarTitleText'>
                                {languageData.general
                                  ? languageData.general.reports
                                  : 'Reports'}
                              </small>
                              <NavbarLink
                                text={
                                  languageData.general
                                    ? languageData.general.my_report
                                    : 'My Reports'
                                }
                                link={'/report'}
                              >
                                <FontAwesomeIcon size='lg' icon={faChartLine} />
                              </NavbarLink>

                              <NavbarLink
                                text={`Manager's report`}
                                link={'/manager-report'}
                              >
                                <FontAwesomeIcon size='lg' icon={faChartArea} />
                              </NavbarLink>

                              {enableExternalReports === 1 ? (
                                <NavbarLink
                                  text='Add external reports'
                                  link={'/settings/external-reports'}
                                >
                                  <FontAwesomeIcon size='lg' icon={faPlus} />
                                </NavbarLink>
                              ) : null}
                              {user?.access === 1 ? (
                                <NavbarLink text={`Orders`} link={'/orders'}>
                                  <FontAwesomeIcon
                                    size='lg'
                                    icon={faClipboardList}
                                  />
                                </NavbarLink>
                              ) : null}
                            </Col>
                          )}
                          {user?.access === 1 && (
                            <Col
                              className='dFlex flexCol itemCenter gap06 py06'
                              onClick={(e) => e.preventDefault()}
                            >
                              <small className='NavbarTitleText'>
                                {languageData.general
                                  ? languageData.general.rewards
                                  : 'Rewards'}
                              </small>
                              <NavbarLink
                                text='Rewards management'
                                link={'/settings/rewards'}
                              >
                                <FontAwesomeIcon size='lg' icon={faAward} />
                              </NavbarLink>
                            </Col>
                          )}
                          {/* </> */}
                          {/* )} */}
                          <Col
                            className='dFlex flexCol itemCenter gap06 py06'
                            onClick={(e) => e.preventDefault()}
                          >
                            <small className='NavbarTitleText'>Help</small>

                            <NavbarLink
                              text={
                                languageData.settings
                                  ? languageData.settings.contact_us
                                  : 'Contact us'
                              }
                              link={'/settings/help'}
                            >
                              <FontAwesomeIcon
                                size='lg'
                                icon={faQuestionCircle}
                              />
                            </NavbarLink>
                          </Col>

                          {window.innerWidth > 768 &&
                            [1, 2, 4, 5].includes(user?.access) && (
                              <Col
                                className='dFlex flexCol itemCenter gap06 py06'
                                onClick={(e) => e.preventDefault()}
                              >
                                <small className='NavbarTitleText'>
                                  Question Bank
                                </small>
                                <NavbarLink
                                  text='Add questions'
                                  link={'/settings/question-bank'}
                                >
                                  <FontAwesomeIcon size='lg' icon={faPlus} />
                                </NavbarLink>
                              </Col>
                            )}
                          <Col
                            className='dFlex flexCol itemCenter gap06 py06'
                            onClick={(e) => e.preventDefault()}
                          >
                            <small className='NavbarTitleText'>
                              Slack Channels
                            </small>
                            <NavbarLink
                              text='Slack Channels'
                              link={'/slack-channels'}
                            >
                              <FontAwesomeIcon size='lg' icon={faSlack} />
                            </NavbarLink>
                          </Col>
                          {/* <Col
                         className='dFlex flexCol itemCenter gap06 py06'
                        onClick={(e) => e.preventDefault()}
                      >
                        <div className=' '>
                          <div className=''>
                            <small className='NavbarTitleText'>
                              External links
                            </small>
                            {general.showFirstLink && (
                              <small className='mb-1'>
                                <Link
                                  className=' itemsCenter'
                                  to={general.firstLink.URL}
                                >
                                  <FontAwesomeIcon
                                    size='lg'
                                    icon={faArrowUpRightFromSquare}
                                  />
                                  <span>{general.firstLink.name}</span>
                                </Link>
                              </small>
                            )}
                            {general.showSecondLink && (
                              <small className='mb-1'>
                                <Link
                                  className='d-flex itemsCenter'
                                  to={general.secondLink.URL}
                                >
                                  <FontAwesomeIcon
                                    size='lg'
                                    icon={faArrowUpRightFromSquare}
                                  />
                                  <span>{general.secondLink.name}</span>
                                </Link>
                              </small>
                            )}
                            {general.showThirdLink && (
                              <small className='mb-1'>
                                <Link
                                  className='d-flex itemsCenter'
                                  to={general.thirdLink.URL}
                                >
                                  <FontAwesomeIcon
                                    size='lg'
                                    icon={faArrowUpRightFromSquare}
                                  />
                                  <span>{general.thirdLink.name}</span>
                                </Link>
                              </small>
                            )}
                          </div>
                        </div>
                      </Col> */}
                        </Row>
                      </div>
                    )}
                  </div>
                  <UncontrolledDropdown nav class>
                    <DropdownToggle
                      className='nav-link pr-0 pl-0 '
                      color=''
                      tag='a'
                    >
                      <Media className='itemsCenter cursorPointer'>
                        <span className='avatar avatar-sm rounded-circle'>
                          <img
                            className='avatar-fit'
                            alt='...'
                            src={
                              user?.avatar?.url
                                ? user?.avatar?.url
                                : defaultAvatar
                            }
                          />
                        </span>
                        <Media className='ml-2 d-none d-lg-block'>
                          <span className='mb-0 text-sm font-weight-bold'>
                            {(user?.first_name ? user?.first_name : 'name') +
                              ' ' +
                              (user?.last_name ? user?.last_name : 'lastname')}
                          </span>
                        </Media>
                      </Media>
                    </DropdownToggle>
                    <DropdownMenu right className='notifications-dropdown'>
                      <DropdownItem className='DropdownItemHeader' header>
                        <span>{user?.first_name || 'Guest'}</span>
                        <span>{user?.email || 'guest@example.com'}</span>
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem
                        href='/profile'
                        onClick={(e) => {
                          e.preventDefault()
                          history.push('/profile')
                        }}
                        className='linkHover'
                      >
                        <i className='ni ni-single-02' />
                        <span>
                          {language ? language?.my_profile : 'My Profile'}
                        </span>
                      </DropdownItem>
                      {user?.is_proxied && (
                        <DropdownItem
                          className='linkHover'
                          onClick={() => dispatch(resetProxy())}
                        >
                          <FontAwesomeIcon icon={faArrowLeft} />
                          <span>Switch back</span>
                        </DropdownItem>
                      )}
                      <DropdownItem
                        href='/profile'
                        onClick={(e) => {
                          e.preventDefault()
                          history.push('/my-orders')
                        }}
                        className='linkHover'
                      >
                        <FontAwesomeIcon
                          icon={faClipboardList}
                          style={{ marginLeft: '2px' }}
                        />
                        <span>My Orders</span>
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem
                        className='logoutLinkHover'
                        onClick={handleLogout}
                        tag='a'
                      >
                        {/* <i className='ni ni-user-run' /> */}
                        <FontAwesomeIcon icon={faRightFromBracket} />
                        <span>{language ? language?.logout : 'Log Out'}</span>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </Nav>
            </div>
          </Collapse>
        </Container>
      </Navbar>
    </div>
  )
}

AdminNavbar.propTypes = {
  toggleSidenav: PropTypes.func,
  sidenavOpen: PropTypes.bool,
  theme: PropTypes.oneOf(['dark', 'light']),
}

export default AdminNavbar
